import React, { FC } from 'react';
import { localizedAmount } from 'utils/localeHelpers';
import Style from './Amount.style';
import { currencySymbol } from 'utils';

type TProps = {
  value: number;
  currency?: 'eur' | string;
  className?: string;
};

export const Amount: FC<TProps> = ({ value, currency = 'eur', className }) => {
  return (
    <Style className={className}>
      {localizedAmount(value / 100)} {currencySymbol(currency)}
    </Style>
  );
};
